import React from 'react'
import FormInput from './formInput'
import { config } from '../Config/config'
// import DetailDoctorService from '../Service/DetailDoctorService'

export default class catalogForm extends React.Component {
    AppointmentModel = {
        // _id: "",
        customer_id: "",
        doctor_office_id: "",
        doctor_office_schedule_id: "",
        doctor_office_treatment_id: "",
        appointment_date: "",
        is_delete: false,
        biodata_id: localStorage.getItem(config.biodata_id),
        doctor_id: localStorage.getItem(config.cariIdDoctor),
        medical_facility_id: "",
        created_by: localStorage.getItem(config.userid),

        tanggal_datang: "",
        tanggal_datang2: "",
        day: "",
        faskes: "",
        // nama_dokter: "",
        jam: "",
    }

    constructor() {
        super()
        this.state = {
            ShowModalJanji: false,
            ShowModal: false,
            // bioList: [],
        }
    }


    cekChat = () => {

    }

    render() {
        const { data, ListAlamat, detailDoctor, Model, bioList, ListPengalaman, ListJadwal, dispOff, dispOn, isOnline, janjiHandler,
            hasil, status, doctor_id } = this.props
        const { ShowModalJanji } = this.state
        return (
            // <div class="profile-header col-6">
            <div class="col-sm-6 col-6">

                <div class="card-box" style={{ border: "solid lightBlue" }}>
                    <div class="row">
                        <div class="mb-6 col-8">

                            <div class="card-body" style={{ height: 170 }}>
                                <h3 class="widget-user-username">{data._id}</h3>
                                <h5 class="widget-user-desc" style={{ textIndent: 10 }}>{data.spesialis}</h5>
                                <h5 class="widget-user-desc" style={{ textIndent: 10 }}>{data.Lama_Pengalaman} Tahun Pengalaman</h5><br />

                                {
                                    ListAlamat.map(alamat => {
                                        if (data._id == alamat._id) {
                                            var ListRS = alamat.rumahSakit
                                            var alamatRS = alamat.alamatRS
                                            var lokasiRS = alamat.lokasiRS
                                            return (
                                                ListRS.map(rs => {
                                                    return (
                                                        alamatRS.map(alRS => {
                                                            if (rs.location_id == alRS[0]._id) {

                                                                return (
                                                                    lokasiRS.map(lokRs => {
                                                                        if (alRS[0].parent_id == lokRs[0]._id) {
                                                                            return (
                                                                                <div>
                                                                                    <h5 class="widget-user-desc" style={{ textIndent: 5 }}><i class="fa fa-building"></i>{rs.name},({alRS[0].name},{lokRs[0].name})</h5>
                                                                                </div>
                                                                            )
                                                                        }

                                                                    })

                                                                )
                                                            }
                                                        })

                                                    )
                                                })
                                            )


                                        }
                                    })
                                }
                            </div>

                            <div class="text-right">
                                <button class="btn btn-white float-center" style={{ width: 300 }} onClick={() => detailDoctor(data.id_doctor)}>Lihat info lebih banyak</button>
                            </div>

                        </div>
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <div class="col-12">
                                        <img class="circle mt-2 ml-1" style={{ width: 100, height: 100 }} src={data.image[0]} alt="" />
                                        <br />
                                    </div>
                                    {/* <div class="col-12">
                                        <div style={{ display: dispOn }}>
                                            <button class="btn btn-default float-center font-weight-bold border border-primary" style={{ width: 100, margin: 10 }}>Chat</button>
                                        </div>
                                        <div style={{ display: dispOff }}>
                                            <button class="btn btn-secondary btn-lg disabled" style={{ width: 100, margin: 10 }}>{isOnline}</button>
                                        </div>
                                    </div> */}
                                    {hasil.map(ket => {
                                        // console.log(ket)
                                        // for (let i = 0; i < ket.length; i++) {
                                        if (data.id_doctor == ket.iddoctor) {
                                            if (ket.dispOn == "") {
                                                return (
                                                    <div class="col-12">
                                                        {/* <div style={{ display: ket.dispOn }}> */}
                                                        <button class="btn btn-default float-center font-weight-bold border border-primary" style={{ width: 100, margin: 10 }}>Chat</button>
                                                        {/* </div> */}
                                                        {/* <div style={{ display: ket.dispOff }}>
                                                                <button class="btn btn-secondary btn-lg disabled" style={{ width: 100, margin: 10 }}>Offline</button>
                                                            </div> */}
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    <div class="col-12">
                                                        {/* <div style={{ display: ket.dispOn }}>
                                                                <button class="btn btn-default float-center font-weight-bold border border-primary" style={{ width: 100, margin: 10 }}>Chat</button>
                                                            </div> */}
                                                        {/* <div style={{ display: ket.dispOff }}> */}
                                                        <button class="btn btn-secondary btn-lg disabled" style={{ width: 100, margin: 10 }}>Offline</button>
                                                        {/* </div> */}
                                                    </div>
                                                )
                                            }
                                        }
                                        // }
                                    })}

                                    <div class="col-12">
                                        {/* <button class="btn btn-primary float-center font-weight-bold" style={{ color: "white" }} onClick={janjiHandler}>Buat Janji</button> */}
                                        <button class="btn btn-primary float-center font-weight-bold" style={{ color: "white" }} onClick={() => janjiHandler(data.id_doctor)}>Buat Janji</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <FormInput
                            ShowModalJanji={ShowModalJanji}
                            janjiHandler={this.janjiHandler}
                            // bioList={bioList}
                            // cancelHandler={this.cancelHandler}
                            // errors={errors}
                            // Mode={Mode}
                            // image={this.state.image}
                            // disabled={disabled}
                        /> */}

                    </div>
                </div>
            </div>
        )
    }
}